export enum PlugType {
  TUSSEN = 'TUSSEN',
  NEUS = 'NEUS',
  POT = 'POT',
  WORTEL = 'WORTEL',
  OOG = 'OOG',
  KOP = 'KOP',
  ZAAI = 'ZAAI'
}
